module.exports = __webpack_public_path__ + "static/img/reviewed.2aa941c4.png";